<template>
  <div>
    <v-head></v-head>
    <div class="detail_bg">
      <img src="../assets/pic03.png" alt="">
      <div class="detail_txt">
        <div class="title">
          智能运维视频辅助巡检机器人
        </div>
        <div class="txt">
          Intelligent operation and maintenance video-assisted inspection robot
        </div>
      </div>
    </div>
    <div class="detail_content">
      <div>
        <div class="title">项目概况</div> 
        <div class="txt">
          <p>2020年3月份-6月份在上海市市南配电站完成地面引导线铺设和一台地面式运维巡检机器人的部署任务，并开展了为期3个月的性能
调试、功能验证及优化改进工作。</p>
          <p>2020年10月份在博世站部署安装，参与进博会保电行动。</p>
        </div> 
      </div>
      <div>
        <div class="title">现场图片</div> 
        <div class="img_one">
          <div class="list_one">
            <img src="../assets/pic3.png" alt="">
          </div>
          <div class="list_one">
            <img src="../assets/pic32.png" alt="">
          </div>
        </div> 
        <div class="img_one">
          <div class="list_one">
            <img src="../assets/pic33.png" alt="">
          </div>
          <div class="list_one">
            <img src="../assets/pic34.png" alt="">
          </div>
        </div> 
      </div>
    </div>

    
    <v-foot class="detail_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    }
  }
}
</script>
<style scoped>

.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.detail_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.detail_txt {
  position: absolute;
  top: 280px;
  left: 350px;
  color: #fff ;
}
.detail_txt .title {
  font-size: 58px;
}
.detail_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.detail_text {
  display: flex;
}
.detail_content {
  width: 1000px;
  margin: 0 auto;
  color: #666;
}
.detail_content .title {
  font-size: 24px;
  margin-top: 40px;
}
.detail_content .txt {
  margin-top: 15px;
}
.detail_content .txt p {
  font-size: 16px;
  text-indent: 2em;
  margin-top: 3px
}
.img_one {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 1000px;
  flex: 2;
  justify-content: space-between;
  margin-top: 20px;
}
.img_one img {
  width: 450px;
  height: 380px;
}
.img_one .img1 {
  width: 450px;
  height: 480px;
}
.img_one .txt {
  margin-top: 6px;
  width: 450px;
  margin-bottom: 10px;
  font-size: 13px;
}


.detail_foot {
  margin-top: 100px;
}

</style>


// WEBPACK FOOTER //
// src/components/Detail6.vue